export const queryFilterNameToLabelMap: Record<string, string> = {
  calendarDaysDelinquent: 'Calendar days delinquent',
  calendarDaysDelinquentFrom: 'Calendar days delinquent from',
  calendarDaysDelinquentTo: 'Calendar days delinquent to',
  feesPaid: 'Fees paid',
  fullNameCustomer: 'Borrower name',
  loanAmount: 'Loan amount',
  loanAmountFrom: 'Loan amount from',
  loanAmountTo: 'Loan amount to',
  loanDueFrom: 'Loan due from',
  loanDueTo: 'Loan due to',
  loanStatuses: 'Loan status',
  nextPaymentDate: 'Next payment date',
  nextPaymentDateFrom: 'Next payment date from',
  nextPaymentDateTo: 'Next payment date to',
  principalPaid: 'Principal paid',
  products: 'Plan',
  providers: 'Provider',
  requestedAmount: 'Requested amount',
  requestedAmountFrom: 'Requested amount from',
  requestedAmountTo: 'Requested amount to',
  requestedDate: 'Requested date',
  requestedDateFrom: 'Requested date from',
  requestedDateTo: 'Requested date to',
  totalDue: 'Loan due',
  totalFeesPaidFrom: 'Fees paid from',
  totalFeesPaidTo: 'Fees paid to',
  totalPrincipalPaidFrom: 'Principal paid from',
  totalPrincipalPaidTo: 'Principal paid to',
};

export function getLabelName(queryFilterName: string): string {
  return queryFilterNameToLabelMap[queryFilterName] ?? queryFilterName;
}
